(function ($) {
  Drupal.behaviors.productFilters = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $filterSets = $('.js-filter-set-wrapper', context);
      var $allTriggers = $('.js-filter-trigger', $filterSets);
      var qs = Drupal.behaviors.quickshop;

      $filterSets.each(function () {
        var $thisFilterSet = $(this); // Used to find the no results message
        var $mixItUpEl = $('.js-filterable-items-wrapper', this);
        var $triggerSets = $('.product-filter', this);
        var $productGrid = $mixItUpEl.closest('.js-product-grid');
        var $altGrid = $mixItUpEl.closest('.js-product-grid-alt');
        var isProductGrid = !!$productGrid.length;
        var isAltGrid = !!$altGrid.length;
        var isInlineBlock = $(this).hasClass('js-mix-it-up-inline-block');
        var sequential = !!$(this).data('sequential-filtering');

        if (sequential) {
          $triggerSets.addClass('disabled').first().removeClass('disabled');
        }

        $triggerSets.each(function () {
          var $triggers = $('.js-filter-trigger', this);
          var $set = $(this);
          var $firstFilter = $set.find('li.product-filter__item:first');
          var $productFilterList = $set.find('ul.js_product-filter__list');
          var $skinSet = 'type-finder--' + $set.children('.js_product-filter__label').text().split(' ').join('-');

          $productFilterList.attr({
            'role': 'radiogroup',
            'aria-labelledby': $skinSet
          });
          $productFilterList.parent().attr('id', $skinSet);
          $firstFilter.attr({
            'tabindex': '0',
            'role': 'radio',
            'aria-checked': 'false'
          });
          $set.find('li').not(':first').each(function () {
            $(this).attr({
              'tabindex': '-1',
              'role': 'radio',
              'aria-checked': 'false'
            });
          });
          if ($('.js-filter-set', $thisFilterSet).hasClass('js-active-first')) {
            $('.js-filter-trigger').first().addClass('active');
          }
          var $filterSelect = $('.js-filter-trigger_dropdown', $thisFilterSet);

          $filterSelect.on('change', function () {
            $mixItUpEl.mixItUp('filter', '.product-grid__item--filterable--' + this.value.toUpperCase());
          });

          $triggers.on('click', function (event) {
            event.preventDefault();
            if (sequential && $set.hasClass('disabled')) {
              return;
            }
            var active = !$(this).hasClass('active');

            $triggers.removeClass('active');
            $(this).toggleClass('active', active);

            if (sequential && !active) {
              $set.nextAll().find('.js-filter-trigger.active').removeClass('active');
            }

            var filters = [];

            $allTriggers.filter('.active').each(function () {
              var filter = $(this).data('filter');

              if (filter) {
                // Locales already using this module might not have category names in full capitals
                // but filterable products are using all-capital category names
                var filter_name = filter.match('(.product-grid__item--filterable--)(.+)');

                if (filter_name[1] && filter_name[2]) {
                  filter = filter_name[1] + filter_name[2].toUpperCase();
                }
                filters.push(filter);
              }
            });

            // Use filters.join(',') for "or" logic
            var filterString = filters.join('') || 'all';

            if ($mixItUpEl.mixItUp('isLoaded')) {
              if (sequential) {
                $set.next().toggleClass('disabled', !active);
                // If a filter has the disabled class, we're not filtered.
                if (isAltGrid && $set.next().hasClass('disabled')) {
                  $altGrid.removeClass('product-grid-alt--filtered');
                }
              }
              $mixItUpEl.mixItUp('filter', filterString);
            }
          });
        });

        var mixItUpArgs = {
          animation: {
            duration: 1000
          },
          selectors: {
            target: '.js-filter-item'
          },
          load: {
            filter: 'all'
          },
          controls: {
            enable: false
          },
          layout: {
            display: isInlineBlock ? 'inline-block' : 'block'
          }
        };

        // if (isAltGrid) {
        //   mixItUpArgs.animation.animateResizeTargets = true;
        // }

        $mixItUpEl.addClass('mixitup-initialized').mixItUp(mixItUpArgs);
        $mixItUpEl.on('mixStart', function (event, state, futureState) {
          // Alt grid has a different number of columns depending on the number
          // of results
          if (isAltGrid) {
            if (sequential && $triggerSets.hasClass('disabled')) {
              return;
            }

            $altGrid.removeClass('product-grid-alt--results-gte-15 product-grid-alt--results-gte-5 product-grid-alt--results-lt-5 product-grid-alt--centered product-grid-alt--filtered');
            if (futureState.totalShow >= 15) {
              $altGrid.addClass('product-grid-alt--results-gte-15 product-grid-alt--filtered');
            } else if (futureState.totalShow >= 5) {
              $altGrid.addClass('product-grid-alt--results-gte-5 product-grid-alt--filtered');
            } else {
              $altGrid.addClass('product-grid-alt--results-lt-5 product-grid-alt--filtered');
              if (futureState.totalShow <= 3) {
                $altGrid.addClass('product-grid-alt--centered product-grid-alt--filtered');
              }
            }
          }

          // Destroy all quickshops when filtering:
          if (isProductGrid) {
            qs.reset($productGrid);
          }

          // Show or hide the no results message
          $('.no-matches__message', $thisFilterSet).toggle(futureState.totalShow === 0);
        }).on('mixEnd', function () {
          // Re-attach quickshops:
          if (isProductGrid) {
            qs.initGrid($productGrid, Unison.fetch.now().name);
          }
        }).on('mixLoad', function () {
          // Resize grid on load:
          if (isProductGrid) {
            // Re-init quickshop
            qs.initGrid($productGrid, Unison.fetch.now().name);
            // Run equal heights:
            Drupal.behaviors.productGrid.equalHeights();
          }
        });
      });
    },
    attached: false
  };
})(jQuery);
